import { __spreadArray } from "tslib";
import React from "react";
import s from './radio.module.css';
//TODO: need to add sizes and disabled state
export function Radio(_a) {
    var _b = _a.label, label = _b === void 0 ? '' : _b, _c = _a.size, size = _c === void 0 ? 24 : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.className, className = _e === void 0 ? '' : _e, _f = _a.value, value = _f === void 0 ? '' : _f, _g = _a.name, name = _g === void 0 ? '' : _g, _h = _a.onChange, onChange = _h === void 0 ? function (e) { } : _h;
    var classNames = __spreadArray(__spreadArray([
        s.container,
        s["size__".concat(size)]
    ], (disabled ? [s.disabled] : []), true), [
        className,
    ], false).join(' ');
    return (React.createElement("label", { className: classNames },
        React.createElement("input", { type: "radio", name: name, value: value, disabled: disabled, onChange: onChange }),
        React.createElement("span", { className: s.checkmark }),
        React.createElement("span", { className: s.text }, label)));
}
//# sourceMappingURL=Radio.js.map